import dictionary from "../dictionary";
import methods from "../methods";

const { property } = dictionary;
const { get, post, patch, put, deleteData } = methods;

const PropertyService = {
  createRRoomPropertyService: (body) => {
    return post(property.createRroomProperty(), body);
  },
  updateRRoomPropertyService: (data) => {
    return put(property.updateRroomProperty(data.id), data.body);
  },
  getRroomsPropertyService: () => {
    return get(property.getRroomProperty());
  },
  getRroomsPropertyServiceByOwner: (email) => {
    return get(property.getRroomProperty() + `?ownerEmail=${email}`);
  },
  getRroomsPropertyByFilter: (filter) => {
    return get(property.getRroomProperty() + filter);
  },
  deleteRRoomPropertyService: (id) => {
    return deleteData(property.getRroomProperty() + "/" + id);
  },
  getSinglePropertyService: (id, fullDetail) => {
    return get(
      property.getRroomProperty() +
      "/" +
      id +
      `${fullDetail ? "?showDetails=true" : ""}`
    );
  },
  createRRoomService: (body) => {
    return post(property.createRroom(), body);
  },
  updateRRoomService: (data) => {
    return put(property.updateRroom(data.id), data.body);
  },
  getRRoomService: () => {
    return get(property.createRroom());
  },
  getPropertyCategoryService: () => {
    return get(property.getPropertyCategory());
  },
  getPropertyCategoryServiceId: (id) => {
    return get(property.getPropertyById(id) + "?showDetails=true");
  },
  createPropertyCategoryService: (body) => {
    return post(property.getPropertyCategory(), body);
  },
  editPropertyCategoryService: (data) => {
    return put(property.getPropertyCategory() + `/${data.id}`, data.body);
  },
  deletePropertyCategoryService: (id) => {
    return deleteData(property.getPropertyCategory() + `/${id}`);
  },
  getRoomCategoryService: () => {
    return get(property.getRoomCategory());
  },
  createRoomCategoryService: (body) => {
    return post(property.getRoomCategory(), body);
  },
  editRoomCategoryService: (data) => {
    return put(property.getRoomCategory() + `/${data.id}`, data.body);
  },
  deleteRoomCategoryService: (id) => {
    return deleteData(property.getRoomCategory() + `/${id}`);
  },
  getAmenitiesService: () => {
    return get(property.getAmenities());
  },
  createAmenitiesService: (body) => {
    return post(property.getAmenities(), body);
  },
  editAmenitiesService: (data) => {
    return put(property.getAmenities() + `/${data.id}`, data.body);
  },
  deleteAmenitiesService: (id) => {
    return deleteData(property.getAmenities() + `/${id}`);
  },
  bookHotelService: (body) => {
    return post(property.bookHotel(), body);
  },
  getBookHotelService: (body) => {
    return get(property.bookHotel());
  },
  getBookHotelByUser: (id, page, limit) => {
    return get(property.bookHotelByUser(id, page, limit));
  },
  createEnquiryService: (body) => {
    return post(property.createEnquiry(), body);
  },
  getEnquiryService: (body) => {
    return get(property.createEnquiry());
  },

  

  createWalkingBookingService: (body) => {
    return post(property.createWalkingBooking(), body);
  },
  searchPropertyService: (body) => {
    return post(property.searchProperty(), body);
  },
  searchPropertyServiceGet: (body) => {
    return get(
      body ? property.searchPropertyGet() + body : property.searchPropertyGet(), { hideLoader: true }
    );
  },
  updateBookingService: (data) => {
    return put(property.updateBooking(data.id), data.body);
  },
  getBookingServiceByProperty: (id) => {
    return get(property.updateBooking(id));
  },
  deletePropertyImageService: (id) => {
    return deleteData(property.deletePropertyImage(id));
  },
  deleteRoomImageService: (id) => {
    return deleteData(property.deleteRoomImage(id));
  },
  getInventoryEmplyoee: () => {
    return get(property.getEmployee());
  },
  editInvoiceData: (data) => {
    return post(property.invoiceDatasubmit(), data);
  },
  reEditInvoiceData: (data, id) => {
    return put(property.invoiceDatasubmit() + `/${id}`, data);
  },
  getInvoiceData: (id) => {
    return get(property.invoiceDatasubmit() + id);
  },
  getFoodOrders: () => {
    return get(property.foodOrders());
  },
  getFoodOrdersByBooking: (id) => {
    return get(property.foodOrdersByBooking(id));
  },
  getFoodOrdersByProperty: (id) => {
    return get(property.foodOrdersByPrt(id), { hideLoader: true });
  },
  getFoodOrdersByPropertyId: (data) => {
    return post(property.foodOrdersByPrtId(), data, { hideLoader: true });
  },
  getFoodOrdersPaymentReport: (data) => {
    return post(property.foodOrderPaymentReportByPrtId(), data, { hideLoader: true });
  },
  transactionReport: (data) => {
    return post(property.viewTransactionReport(), data, { hideLoader: true });
  },
  createFoodOrders: (data) => {
    return post(property.foodOrders(), data);
  },
  updateFoodOrders: (data, id) => {
    return put(property.foodOrders() + "/" + id, data);
  },
  deleteFoodOrders: (id) => {
    return get(property.foodOrders() + "/" + id);
  },
  getFoodItems: () => {
    return get(property.foodItems());
  },
  getFoodItemsProperty: (id) => {
    return get(property.foodItems() + id);
  },
  createFoodItems: (data) => {
    return post(property.foodItems(), data);
  },
  createFoodItemInventory: (data) => {
    return post(property.foodItems(), data);
  },
  updateFoodItems: (data, id) => {
    return put(property.foodItems() + "/" + id, data);
  },
  deleteMenuItems: (id) => {
    return deleteData(property.foodItems() + "/" + id);
  },
  updateInventoryItemByFoodId: (id, data) => {
    return put(property.updateInventoryItemByFoodId(id), data);
  },
  createPaymentFood: (data) => {
    return post(property.foodPayment(), data);
  },
  updatePaymentFood: (data, id) => {
    return put(property.foodPayment() + id, data);
  },
  updateFoodOrderStatus: (data, id) => {
    return patch(property.foodOrderStatus(id), data);
  },
  foodOrderDiscountService: (data, id) => {
    return post(property.foodOrderDiscount(id), data)
  },
  kotOrderDiscountService: (data, id) => {
    return post(property.kotOrderDiscount(id), data)
  },
  kotPaymentservice: (data) => {
    return post(property.kotPayment(), data)
  },
  getCountry: (id) => {
    return get(property.country() + id);
  },
  paymentGateway: (id, body) => {
    return get(property.paymentGatewayUrl(id, body));
  },
  paymentGatewayStatus: (id) => {
    return get(property.paymentStatusUrl(id));
  },
  updateBookingModeStatus: (id, params) => {
    return put(property.updateBookingModeStatus(id), params);
  },
  getBookingById: (id) => {
    return get(property.updateBooking(id));
  },
  getStatusOfPaymentSucces: (id) => {
    return get(property.paymentStatus(id));
  },
  getNcType: () => {
    return get(property.ncType());
  },
  getNcTypeByProperty: (id) => {
    return get(property.ncTypeByProperty(id));
  },
  setNcType: (data) => {
    return post(property.ncType(), data);
  },
  editNcType: (id, data) => {
    return put(property.ncType() + id, data);
  },
  getwalletMoney: (id) => {
    return get(property.walletMoney(id));
  },
  getActivityByBooking: (id) => {
    return get(property.activityByBooking(id));
  },
  createActivity: (params) => {
    return post(property.activity(), params);
  },
  createKotActivity: (params) => {
    return post(property.createKotLogs(), params);
  },
  getKotActivity: (id) => {
    return get(property.getKotLogs(id));
  },

  getTaEnqueriesService: () => {
    return get(property.getTaEnqueries());
  },
  taCreateBookingService: (params) => {
    return post(property.taCreateBooking(), params);
  },
  addTaCommisionService: (params) => {
    return post(property.addTaCommision(), params);
  },
  taUsersService: (param) => {
    return get(property.taUsers(param));
  },

  propertyListService: () => {
    return get(property.propertyList());
  },
  propertyLogsService: (params) => {
    return post(property.propertyLogs(), params);
  },
  getPropertyLogsService: (id) => {
    return get(property.getPropertyLogs(id));
  },

  getDsrService: (id) => {
    return get(property.getDsr(id));
  },
  createDsrService: (params) => {
    return post(property.createDsr(), params);
  },
  editDsrService: (id, params) => {
    return put(property.editDsr(id), params);
  },
  getDayCloserService: (id) => {
    return get(property.getDayCloser(id));
  },

  ownershipTransferService: (params) => {
    return post(property.ownershipTransfer(), params);
  },

  getFocRequest: (id) => {
    return get(property.focRequest(id));
  },
  editFocRequest: (id, params) => {
    return put(property.focRequestEdit(id), params);
  },
  updatePropertyProfile: (id, data) => {
    return put(property.updatePropetyHeroImg(id), data);
  },
  updateRoomPrice: (payload, id) => {
    return put(property.updateRoomPriceURL(id), payload);
  },
  bookingUserListForRrooms: (payload) => {
    return post(property.bookingByNumber(), payload);
  },
  foodPaymentHistory: (payload) => {
    return post(property.foodOrderPayments(), payload);
  },
  deleteAssignProperty: (payload) => {
    return deleteData(property.removeAssignProperty(), payload);
  },
  bookingReportService: (startDate, endDate, propertyId, status, source) => {
    return get(property.bookingReport(startDate, endDate, propertyId, status, source))
  },

  changePropertyStatus: (payload) => {
    return put(property.changePropertyStatus(), payload)
  },

  propertyActionLogsService: (payload) => {
    return post(property.propertyActionLogs(), payload)
  },
  getPropertyActionLogsService: (id) => {
    return get(property.getPropertyActionLogs(id))
  },
  getExportProperties: (approved, status, config) => {
    return get(property.exportProperties(approved, status), config)
  },

  searchBookingService: (id, query, limit, page, loginType) => {
    return get(property.searchBooking(id, query, limit, page, loginType))
  },

  allZoneService: () => {
    return get(property.allZones())
  },
  getStateByZone: (id) => {
    return get(property.stateByZone(id))
  },
  getHubByState: (id) => {
    return get(property.hubByState(id))
  },
  getCityByHub: (id) => {
    return get(property.cityByHub(id))
  },

  roomAvailalityService: (body) => {
    return post(property.roomAvailality(), body);
  },

  bookingCountBySourceService: (id, params)=>{
    return get(property.bookingCountBySource(id, params))
  },
  foodsCountByStatusService: (id, params)=>{
    return get(property.foodsCountByStatus(id, params))
  },


  saveCompanyBillingInfoService: (data) => {
    return post(property.saveCompanyBillingInfo(), data)
  },

  invoiceGenrateByDateService: (data) => {
    return post(property.invoiceGenrateByDate(), data)
  },
  


  roomOccupancyForTodayService: (propertyId) => {
    return get(property.roomOccupancyForToday(propertyId))
  },
  roomOccupancyByDateService: (propertyId, url) => {
    return get(property.roomOccupancyByDate(propertyId, url))
  },

  customerEnquiryAssignService: (id, data) => {
    return put(property.customerEnquiryAssign(id), data)
  },

  verifyPhoneNumberService: (data) => {
    return post(property.verifyPhoneNumber(), data)
  },
  verifyEmailIdService: (data) => {
    return post(property.verifyPropertyEmail(), data)
  },
  checkOwnerExistService: (data) => {
    return post(property.checkOwnerExist(), data)
  },

  removeExtraChargeService: (data, id) => {
    return put(property.removeExtraCharges(id), data)
  },
  getNearestProperty: (id) => {
    return get(property.nearestProerpty(id))
  },
  tranferBookingService: (data) => {
    return post(property.transferBooking(), data)
  },
  deleteRoomService: (data) => {
    return post(property.deleteBookingRoom(), data)
  },
  getPropertyByArea: (params)=>{
    return get(property.propertyByArea(params))
  },
  getBookingsByArea: (params)=>{
    return get(property.bookingsByArea(params))
  },
  updateAreaBooking: (id, data)=>{
    return put(property.editAreaBooking(id), data)
  },

  createRoomService: (data)=>{
    return post(property.createRoom(), data)
  },
  checkRoomStatusService: (data)=>{
    return post(property.checkRoomStatus(), data)
  },
  removeRoomService: (id)=>{
    return deleteData(property.deleteRoom(id))
  },
  editRoomService: (data)=>{
    return put(property.editRoom(), data)
  },

  tsEnquiriesService: (query, page, limit)=>{
    return get(property.tsEnquiries(query, page, limit))
  },
  editTsEnquiriesService: (id, params)=>{
    return put(property.editTsEnquiries(id), params)
  },

  deleteBookingPaymentService: (body)=>{
    return post(property.deleteBookingPayment(), body)
  },
  deleteFoodPaymentService: (body)=>{
    return post(property.deleteFoodPayment(), body)
  },
};

export default PropertyService;
